import { render, staticRenderFns } from "./WorkOrderCenter.vue?vue&type=template&id=990e2752&scoped=true"
import script from "./WorkOrderCenter.vue?vue&type=script&lang=js"
export * from "./WorkOrderCenter.vue?vue&type=script&lang=js"
import style0 from "./WorkOrderCenter.vue?vue&type=style&index=0&id=990e2752&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "990e2752",
  null
  
)

export default component.exports